import { PATHS } from "@/lib/router";
import { Navigate } from "react-router-dom";
import {
  TargetSummaryPage,
  ESGInviteAcceptPage,
  PreviewReportPage,
  ReportListPage,
  MetricsAssignmentPage,
  AssignMasterData,
} from "./pages";
import { ReportingBoundaryPage } from "@/features/reporting-boundary";
import { EsgForm } from "../onboarding";
import AddReportingYearPage from "../reporting-boundary/components/AddReportingYearPage";

export const esgRoutes = [
  {
    path: PATHS.ESG_TARGETS,
    element: <Navigate to={PATHS.TARGET_SETUP} replace />,
    handle: { permission: { resource: "target_setting", action: "view" } },
  },
  {
    path: "/esg/targets-v2/*",
    element: <Navigate to={PATHS.TARGET_SETUP} replace />,
    handle: { permission: { resource: "target_setting", action: "view" } },
  },
  {
    path: "/esg/targets/details/*",
    element: <Navigate to={PATHS.TARGET_SETUP} replace />,
    handle: { permission: { resource: "target_setting", action: "view" } },
  },
  {
    path: PATHS.ESG_MASTER_DATA,
    element: <MetricsAssignmentPage />,
    handle: { permission: { resource: "master_data", action: "view" } },
  },
  {
    path: PATHS.ESG_MASTER_DATA_ASSIGN,
    element: <AssignMasterData />,
    handle: {
      permission: { resource: "master_data", action: "create" },
      blacklistGroup: ["user"],
    },
  },
  {
    path: `${PATHS.ESG_TARGETS_SUMMARY}/:targetId`,
    element: <TargetSummaryPage />,
    handle: { permission: { resource: "target_setting", action: "view" } },
  },
  {
    path: PATHS.ESG_REPORT_PREVIEW,
    element: <PreviewReportPage />,
    handle: { permission: { resource: "esg_reporting", action: "view" } },
  },
  {
    path: PATHS.ESG_REPORT_PREVIEW_LIST,
    element: <ReportListPage />,
    handle: { permission: { resource: "esg_reporting", action: "view" } },
  },
  {
    path: PATHS.ESG_REPORTING_BOUNDARY,
    element: <ReportingBoundaryPage />,
    handle: { permission: { resource: "reporting_boundary", action: "view" } },
  },
  {
    path: PATHS.ESG_REPORTING_BOUNDARY_ADD,
    element: <AddReportingYearPage />,
    handle: {
      permission: { resource: "reporting_boundary", action: "create" },
    },
  },
  {
    path: PATHS.ESG_REPORTING_BOUNDARY_EDIT,
    element: <AddReportingYearPage />,
    handle: {
      permission: { resource: "reporting_boundary", action: "update" },
    },
  },
];

export const esgPublicRoutes = [
  {
    path: PATHS.ESG_INVITE_ACCEPT,
    element: <ESGInviteAcceptPage />,
  },
  {
    path: PATHS.ESG_FRAMEWORKS,
    element: <EsgForm />,
    handle: { permission: { resource: "reports", action: "view" } },
  },
];
